import Settings from 'views/Dashboard/Settings';
import Icons from 'views/Dashboard/Icons';

import SignIn from 'views/Auth/SignIn.js';
import Forgot from 'views/Auth/Forgot.js';

import { HomeIcon, DocumentIcon } from 'components/Icons/Icons';
import Partners from './views/Dashboard/Partners';
import ApiKeys from './views/Dashboard/ApiKeys';
import RequestLogs from './views/Dashboard/RequestLogs';
import PosTransactions from './views/Dashboard/PosTransactions';
import UserPurchases from './views/Dashboard/UserPurchases';
import MarketPrices from './views/Dashboard/MarketPrices';
import BasePrices from './views/Dashboard/BasePrices';
import Stations from './views/Dashboard/Stations';
import ExternalPrices from './views/Dashboard/ExternalPrices';
import SystemSettings from './views/Dashboard/SystemSettings';
import Dashboard from './views/Dashboard/Dashboard';

import {
  FaChartLine,
  FaHandshake,
  FaKey,
  FaClipboardList,
  FaCashRegister,
  FaReceipt,
  FaDollarSign,
  FaCoins,
  FaGasPump,
  FaGlobe,
  FaGear,
} from 'react-icons/fa6';

export const sidebar = [
  {
    path: 'dashboard',
    name: 'Dashboard',
    rtlName: 'لوحة القيادة',
    icon: <FaChartLine color="#8794C2" />,
    iconActive: <FaChartLine color="#099BFF" />,
    component: Dashboard,
    layout: '/',
    endpoints: ['GET:/admin/stats/summary'],
    tabEndpoints: [
      {
        name: '/',
        endpoints: ['GET:/admin/stats/fuel-prices/summary'],
      },
      {
        name: '/general',
        endpoints: ['GET:/admin/stats/summary'],
      },
    ],
  },
  {
    path: 'partners',
    name: 'Partners',
    rtlName: 'لوحة القيادة',
    icon: <FaHandshake color="#8794C2" />,
    iconActive: <FaHandshake color="#099BFF" />,
    component: Partners,
    layout: '/',
    endpoints: ['GET:/admin/partners', 'POST:/admin/partners'],
  },
  {
    path: 'api-keys',
    name: 'API Keys',
    rtlName: 'لوحة القيادة',
    icon: <FaKey color="#8794C2" />,
    iconActive: <FaKey color="#099BFF" />,
    component: ApiKeys,
    layout: '/',
    endpoints: ['GET:/admin/api-keys', 'POST:/admin/api-keys'],
  },
  {
    path: 'request-logs',
    name: 'Request Logs',
    rtlName: 'لوحة القيادة',
    icon: <FaClipboardList color="#8794C2" />,
    iconActive: <FaClipboardList color="#099BFF" />,
    component: RequestLogs,
    layout: '/',
    endpoints: ['GET:/admin/request-logs'],
  },
  {
    path: 'pos-transactions',
    name: 'POS Transactions',
    rtlName: 'لوحة القيادة',
    icon: <FaCashRegister color="#8794C2" />,
    iconActive: <FaCashRegister color="#099BFF" />,
    component: PosTransactions,
    layout: '/',
    endpoints: ['GET:/admin/pos-transactions'],
  },

  {
    path: 'user-purchases',
    name: 'User Purchases',
    rtlName: 'لوحة القيادة',
    icon: <FaReceipt color="#8794C2" />,
    iconActive: <FaReceipt color="#099BFF" />,
    component: UserPurchases,
    layout: '/',
    endpoints: ['GET:/admin/user-purchases', 'GET:/admin/user-purchases/stats'],
  },
  {
    path: 'market-prices',
    name: 'Market Prices',
    rtlName: 'لوحة القيادة',
    icon: <FaDollarSign color="#8794C2" />,
    iconActive: <FaDollarSign color="#099BFF" />,
    component: MarketPrices,
    layout: '/',
    endpoints: ['GET:/admin/market-prices', 'POST:/admin/market-prices'],
  },
  {
    path: 'base-prices',
    name: 'Base Prices',
    rtlName: 'لوحة القيادة',
    icon: <FaCoins color="#8794C2" />,
    iconActive: <FaCoins color="#099BFF" />,
    component: BasePrices,
    layout: '/',
    tabEndpoints: [
      {
        name: '/',
        endpoints: ['GET:/admin/base-prices', 'POST:/admin/base-prices'],
      },
      {
        name: '/next-base-prices',
        endpoints: [
          'GET:/admin/next-base-prices',
          'POST:/admin/next-base-prices',
        ],
      },
    ],
  },
  {
    path: 'stations',
    name: 'Stations',
    rtlName: 'لوحة القيادة',
    icon: <FaGasPump color="#8794C2" />,
    iconActive: <FaGasPump color="#099BFF" />,
    component: Stations,
    layout: '/',
    endpoints: ['GET:/admin/stations', 'POST:/admin/stations'],
  },
  {
    path: 'external-prices',
    name: 'External Prices',
    rtlName: 'لوحة القيادة',
    icon: <FaGlobe color="#8794C2" />,
    iconActive: <FaGlobe color="#099BFF" />,
    component: ExternalPrices,
    layout: '/',
    endpoints: ['GET:/admin/external-prices'],
  },
  {
    path: 'system-settings',
    name: 'System Settings',
    rtlName: 'لوحة القيادة',
    icon: <FaGear color="#8794C2" />,
    iconActive: <FaGear color="#099BFF" />,
    component: SystemSettings,
    layout: '/',
    endpoints: ['GET:/admin/system-settings'],
  },
];

export const other = [
  {
    path: 'settings',
    name: 'Settings',
    rtlName: 'لوحة القيادة',
    icon: <HomeIcon color="inherit" />,
    component: Settings,
    layout: '/',
  },
  {
    path: 'icons',
    name: 'Icons',
    rtlName: 'الرموز',
    // icon: <HomeIcon color="inherit" />,
    component: Icons,
    layout: '/',
  },
];

export const auth = [
  {
    name: 'AUTH',
    category: 'account',
    rtlName: 'صفحات',
    state: 'pageCollapse',
    views: [
      {
        path: '/signin',
        name: 'Sign In',
        rtlName: 'لوحة القيادة',
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: '/auth',
      },
      {
        path: '/forgot-password',
        name: 'Forgot Password',
        rtlName: 'لوحة القيادة',
        icon: <DocumentIcon color="inherit" />,
        component: Forgot,
        layout: '/auth',
      },
    ],
  },
];

const routes = [...sidebar, ...other, ...auth];
export default routes;
